import 'css-chunk:src/feature/gift-card/EditGiftCardModal.module.scss';export default {
  "content": "EditGiftCardModal_content",
  "currency-input": "EditGiftCardModal_currency-input"
};